import './Icon.css'
import DigitaneIcon from './icons/digitaneIcon'

export const DigitaneLogoButton = () => {
  return (
    <a className="icon-border icon-container" href={`/list`}>
      <div className="icon-button">
        <DigitaneIcon className="icon-button" />
      </div>
    </a>
  )
}
